var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManageConfigurations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 17.5C9 16.1193 7.88071 15 6.5 15C5.11929 15 4 16.1193 4 17.5C4 18.8807 5.11929 20 6.5 20C7.88071 20 9 18.8807 9 17.5ZM13 6.5C13 5.97384 13.0919 5.46932 13.2578 5H5.5C4.67157 5 4 5.67157 4 6.5C4 7.32843 4.67157 8 5.5 8H13.2578C13.0919 7.53068 13 7.02616 13 6.5ZM11 17.5C11 18.0262 10.9081 18.5307 10.7422 19H18.5C19.3284 19 20 18.3284 20 17.5C20 16.6716 19.3284 16 18.5 16H10.7422C10.9081 16.4693 11 16.9738 11 17.5ZM22 17.5C22 19.433 20.433 21 18.5 21H9.32715C8.55442 21.625 7.57122 22 6.5 22C4.01472 22 2 19.9853 2 17.5C2 15.0147 4.01472 13 6.5 13C7.57122 13 8.55442 13.375 9.32715 14H18.5C20.433 14 22 15.567 22 17.5ZM15 6.5C15 7.88071 16.1193 9 17.5 9C18.8807 9 20 7.88071 20 6.5C20 5.11929 18.8807 4 17.5 4C16.1193 4 15 5.11929 15 6.5ZM22 6.5C22 8.98528 19.9853 11 17.5 11C16.4288 11 15.4456 10.625 14.6729 10H5.5C3.567 10 2 8.433 2 6.5C2 4.567 3.567 3 5.5 3H14.6729C15.4456 2.37505 16.4288 2 17.5 2C19.9853 2 22 4.01472 22 6.5Z",
    fill: "#1E1E25"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageConfigurations);
export default __webpack_public_path__ + "static/media/Manage-Configurations.2276d660a9756e46a25b8e476eae4ce3.svg";
export { ForwardRef as ReactComponent };